module.exports = "<dropdown :items=items label=\"Drop Me!\" icon=edit icon-position=right large></dropdown>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../src/demos/dropdown/icon-large-dropdown.vue
 ** module id = 252
 ** module chunks = 0
 **/